import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/img_appointment_complete.svg'


const _withScopeId = n => (_pushScopeId("data-v-a5c2e5a0"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "appointment_contents_wrapper" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<div class=\"appointment_layout_image\" data-v-a5c2e5a0><img src=\"" + _imports_0 + "\" alt=\"\" data-v-a5c2e5a0></div><h1 class=\"appointment_title\" data-v-a5c2e5a0><span class=\"appointment_title_text\" data-v-a5c2e5a0>面談の予約を完了しました</span></h1><p class=\"appointment_text\" data-v-a5c2e5a0>以下の日程で予約しました</p>", 3)
const _hoisted_5 = { class: "appointment_layout_complete" }
const _hoisted_6 = { class: "appointment_complete" }
const _hoisted_7 = { class: "appointment_complete_region" }
const _hoisted_8 = { class: "appointment_complete_date" }
const _hoisted_9 = { class: "appointment_complete_type" }
const _hoisted_10 = { class: "appointment_button" }

import { ref, computed } from 'vue';
import BaseButton from '@/components/BaseButton.vue';
import Loading from '@/components/Loading.vue';
import { useRouter } from 'vue-router';
import store from '@/store';


export default /*#__PURE__*/_defineComponent({
  __name: 'AppointmentcompleteView',
  setup(__props) {

const isLoading = ref(false);
const router = useRouter();

const areaName = computed(() => store.getters['appointment/areaName']);
const interviewDateDisplay = computed(() => store.getters['appointment/interviewDateDisplay']);
const interviewTimeDisplay = computed(() => store.getters['appointment/interviewTimeDisplay']);
const mainRegTypeName = computed(() => store.getters['appointment/mainRegTypeName']);

const getInfo = async () => {
  try {
    isLoading.value = true;
    await store.dispatch('appointment/getInterviewInfo');
    isLoading.value = false;
  } catch (e) {
    store.dispatch('toasts/appendTimeToast', { label: '面談予約の取得に失敗しました', duration: null });
    isLoading.value = false;
  }
};

const transitionPage = () => {
  router.push({ name: 'f00' });
};

getInfo();

//gtmタグ
const getCareerId = async () => {
  try {
    isLoading.value = true;
    await store.dispatch('careerId/receive');
    window.parent.dataLayer.push({'userId01': store.getters['careerId/careerId']});
    isLoading.value = false;
  } catch (e) {
    store.dispatch('toasts/appendTimeToast', { label: '求職者情報の取得に失敗しました', duration: null });
    isLoading.value = false;
  }
};
getCareerId();


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(Loading, { "is-loading": isLoading.value }, null, 8, ["is-loading"]),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, _toDisplayString(_unref(areaName)), 1),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(interviewDateDisplay)) + _toDisplayString(_unref(interviewTimeDisplay)), 1),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(mainRegTypeName)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(BaseButton, { onClick: transitionPage }, {
          default: _withCtx(() => [
            _createTextVNode("ホームへ")
          ]),
          _: 1
        })
      ])
    ])
  ]))
}
}

})